import axios from "@/utils/request"
// 获取当前用户群组余额
export function getGroupBalance() {
  return axios({
    url: "/distribution/user/getGroupBalance",
    method: "GET"
  })
}
